import { apiFetch } from "./http";
import type { TicketFile } from "./files";

export interface TicketDetail {
  id: number;
  site_id: number;
  array_id: number | null;
  array_inverter_id: number | null;
  opened_at: string;
  closed_at: string | null;
  status: string;
  severity_opened: number;
  severity_closed: number | null;
  open_reason: string | null;
  diagnosis_json: any | null;
  notes: string | null;
  created_by?: string | null;
  closed_by?: string | null;
  reopen_count?: number;
  metrics?: any;
  files?: TicketFile[];
}

export interface TicketListItem {
  id: number;
  site_id: number;
  array_id: number | null;
  array_inverter_id: number | null;
  opened_at: string;
  closed_at: string | null;
  status: string;
  severity_opened: number | null;
  severity_closed: number | null;
  notes: string | null;
  diagnosis_message?: string | null;
}

type TicketUpdatePayload = {
  notes?: string | null;
  severity_closed?: number | null;
  diagnosis_json?: any | null;
};

type TicketListParams = {
  site_id?: number;
  status?: string;
  severity?: number;
};

const buildQuery = (params?: TicketListParams) => {
  if (!params) return "";
  const search = new URLSearchParams();
  if (params.site_id !== undefined) search.set("site_id", String(params.site_id));
  if (params.status) search.set("status", params.status);
  if (params.severity !== undefined) search.set("severity", String(params.severity));
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export async function getTickets(params?: TicketListParams): Promise<TicketListItem[]> {
  const query = buildQuery(params);
  return apiFetch<TicketListItem[]>(`/tickets${query}`);
}

export async function getTicket(id: number): Promise<TicketDetail> {
  return apiFetch<TicketDetail>(`/tickets/${id}`);
}

export async function updateTicket(id: number, payload: TicketUpdatePayload): Promise<TicketDetail> {
  return apiFetch<TicketDetail>(`/tickets/${id}`, {
    method: "PUT",
    body: payload,
  });
}

export async function startTicket(id: number): Promise<TicketDetail> {
  return apiFetch<TicketDetail>(`/tickets/${id}/start`, { method: "POST" });
}

export async function resolveTicket(id: number): Promise<TicketDetail> {
  return apiFetch<TicketDetail>(`/tickets/${id}/resolve`, { method: "POST" });
}

export async function closeTicket(id: number): Promise<TicketDetail> {
  return apiFetch<TicketDetail>(`/tickets/${id}/close`, { method: "POST" });
}

export async function reopenTicket(id: number): Promise<TicketDetail> {
  return apiFetch<TicketDetail>(`/tickets/${id}/reopen`, { method: "POST" });
}
